import React from 'react';
import {
  Popper,
  Paper,
  ClickAwayListener,
  Fade,
  Typography,
  Box,
  IconButton,
  Icon,
  ListItem,
  ListItemText,
  Switch,
  Tooltip
} from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import { List } from '@material-ui/core/';

import { useTranslation } from 'react-i18next';

interface IProps {
  isConnected: boolean;
  logs: { text: string; dateTime: Date }[];
  start: () => void;
  stop: () => void;
}

const ConnectionStatePopper: React.FC<any> = (props: IProps) => {
  const { isConnected, logs, start, stop } = props;
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();

  const toggleConnection = () => {
    if (isConnected) {
      stop();
    } else {
      start();
    }
  };

  return (
    <>
      <Popper
        key={'connection-panel'}
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        transition
        style={{ zIndex: 1 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper elevation={6}>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Box p={2} display="flex" flexDirection="column" width={450}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography>
                      {isConnected ? t('f-conn-print-adapter-on') : t('f-conn-print-adapter-off')}
                    </Typography>

                    <Tooltip arrow title={isConnected ? t('f-com-disable') : t('f-com-enable')}>
                      <Switch edge="end" color="primary" onChange={toggleConnection} checked={isConnected} />
                    </Tooltip>
                  </Box>

                  {logs.length !== 0 && (
                    <List style={{ maxHeight: 200, overflow: 'auto' }}>
                      {logs.map((log, i) => (
                        <ListItem key={i}>
                          <ListItemText
                            primary={
                              log?.dateTime
                                ? `${String(log.dateTime.getHours()).padStart(2, '0')}:` +
                                  `${String(log.dateTime.getMinutes()).padStart(2, '0')}:` +
                                  `${String(log.dateTime.getSeconds()).padStart(2, '0')}`
                                : ''
                            }
                            secondary={log.text}
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </Box>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>

      <IconButton
        onClick={() => {
          setOpen(true);
        }}
        ref={anchorRef}
        size="small"
      >
        <Icon fontSize="large" color="primary" style={{ color: !isConnected ? red.A400 : undefined }}>
          {isConnected ? 'domain_verification' : 'web_asset'}
        </Icon>
      </IconButton>
    </>
  );
};
export default ConnectionStatePopper;
